import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficeRecurringPayAdjustmentTable extends Layout {
    buttonAddRecurringPayAdjustment: Button;
    sourceOffRecurDeduct: DataSource;
    tableRecurringPayAdjustments: Table;
}
